import type { ReactNode } from "react";
import { Button, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { ArrowLeft24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  root: {
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  header: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    minHeight: "52px",
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  title: {
    flexGrow: 1,
    minWidth: 0,
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  main: {
    flexGrow: 1,
    width: "100%",
    maxWidth: "720px",
    marginLeft: "auto",
    marginRight: "auto",
    boxSizing: "border-box",
    padding: tokens.spacingHorizontalM,
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
  },
  footer: {
    position: "sticky",
    bottom: 0,
    zIndex: 10,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    padding: tokens.spacingHorizontalM,
    paddingBottom: `calc(${tokens.spacingHorizontalM} + env(safe-area-inset-bottom))`,
  },
  footerInner: {
    maxWidth: "720px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    gap: tokens.spacingHorizontalS,
  },
});

/**
 * Struttura di pagina per telefono: intestazione fissa in alto, contenuto
 * scorrevole, barra azioni fissa in basso (rispetta l'area sicura dei telefoni).
 */
export function Shell(props: {
  title: ReactNode;
  onBack?: () => void;
  actions?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  const s = useStyles();
  return (
    <div className={s.root}>
      <header className={s.header}>
        {props.onBack && (
          <Button appearance="subtle" icon={<ArrowLeft24Regular />} aria-label="Indietro" onClick={props.onBack} />
        )}
        <div className={s.title}>{props.title}</div>
        {props.actions}
      </header>
      <main className={mergeClasses(s.main, props.className)}>{props.children}</main>
      {props.footer && (
        <footer className={s.footer}>
          <div className={s.footerInner}>{props.footer}</div>
        </footer>
      )}
    </div>
  );
}
